/**
 * SpecialtyPharmacyPriorAuthProcessSection - Output section for SP prior auth process
 *
 * Displays specialty pharmacy prior authorization process as a top-level accordion section.
 */

import { AccordionContent, AccordionItem, AccordionTrigger } from '@components/ui/accordion';
import React from 'react';

import { FieldPathProvider } from '../context';
import { Field, SectionTriggerScore } from './Field';

interface SpecialtyPharmacyPriorAuthProcessSectionProps {
  data?: Record<string, unknown>;
  sectionId: string;
}

export const SpecialtyPharmacyPriorAuthProcessSection: React.FC<
  SpecialtyPharmacyPriorAuthProcessSectionProps
> = ({ data, sectionId }) => {
  return (
    <AccordionItem value={sectionId} className="border-b">
      <AccordionTrigger className="px-4 py-3 text-sm font-medium hover:bg-muted/50">
        <div className="flex items-center gap-2 flex-1">
          <span>Drug Specialty Pharmacy Prior Auth Process</span>
          <SectionTriggerScore subsectionKey="specialty_pharmacy_prior_auth_process" />
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        <FieldPathProvider prefix="drug.specialty_pharmacy_prior_auth_process">
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <Field
              label="Department Name"
              value={data?.specialty_pharmacy_prior_authorization_department_name}
              fieldId="specialty_pharmacy_prior_authorization_department_name"
            />
            <Field
              label="Turnaround Time"
              value={data?.specialty_pharmacy_prior_authorization_turnaround_time}
              fieldId="specialty_pharmacy_prior_authorization_turnaround_time"
            />
            <Field
              label="Fax Number"
              value={data?.specialty_pharmacy_prior_authorization_fax_number}
              fieldId="specialty_pharmacy_prior_authorization_fax_number"
            />
            <Field
              label="Phone Number"
              value={data?.specialty_pharmacy_prior_authorization_phone_number}
              fieldId="specialty_pharmacy_prior_authorization_phone_number"
            />
            <Field
              label="Website"
              value={data?.specialty_pharmacy_prior_authorization_website}
              fieldId="specialty_pharmacy_prior_authorization_website"
            />
            <Field
              label="Submission Methods"
              value={data?.specialty_pharmacy_prior_authorization_submission_methods}
              fieldId="specialty_pharmacy_prior_authorization_submission_methods"
            />
            <Field
              label="Notification Methods"
              value={data?.specialty_pharmacy_prior_authorization_notification_methods}
              fieldId="specialty_pharmacy_prior_authorization_notification_methods"
            />
            <Field
              label="Requirements"
              value={data?.specialty_pharmacy_prior_authorization_requirements}
              fieldId="specialty_pharmacy_prior_authorization_requirements"
            />
          </div>
        </FieldPathProvider>
      </AccordionContent>
    </AccordionItem>
  );
};
